import React, { useEffect, useState } from 'react'
import Graytextarea from '../../../components/Graytextarea'
import GraytextareaAdjustable from '../../../components/GrayTextareaAdjustable'

const ReviewSystem = ({ patientDBdata, isSavingTheData, patientID, loggedUserProvider, setPatientDBdata, noteID }) => {
    const [tempValue, setTempValue] = useState('')
    const [value, setValue] = useState('')
    console.log(patientDBdata?.currentNote, 'patientDBdata?.currentNote')
    useEffect(() => {
        console.log(patientDBdata?.currentNote?.data, 'patientDBdata?.currentNote?.data')
        const reviewValue = patientDBdata?.currentNote?.data?.reviewOfSystem?.editROS || ''
        setValue(reviewValue)
        setTempValue(reviewValue)
    }, [])
    const handleBlur = async()=>{

  setPatientDBdata((prev) => {
    return {
      ...prev,
      currentNote: {
        ...prev?.currentNote,
        data: {
          ...prev?.currentNote?.data,
          reviewOfSystem: {
            ...prev?.currentNote?.data?.reviewOfSystem,
            editROS: tempValue,
          },
        },
      },
      
      allNotes: prev?.allNotes?.map((note) => {
        if (note?.id === noteID) {
          const parsedData = note?.data ? JSON.parse(note.data) : {}

          return {
            ...note,
            data: JSON.stringify({
              ...parsedData,
              reviewOfSystem: {
                ...parsedData?.reviewOfSystem,
                editROS: tempValue,
              },
            }),
          }
        }
        return note
      }),
    }
  })
    }

    if(!tempValue){
        return
    }
    return (
        <div className='d-flex align-items-start '>
            <div style={{ minWidth: "23%" }}>Review Of System</div>
            <div className='w-100'>
                <GraytextareaAdjustable
                    value={tempValue}
                    onBlur={handleBlur}
                    onChange={(e) => {
                        setTempValue(e.target.value)
                    }}
                />
            </div>
        </div>
    )
}

export default ReviewSystem